import { Map } from 'immutable';
import {
    GET_RETRIEVEINVENTORY,
    GET_RETRIEVEROOMTYPES,
    GET_HOUSEHOLDITEMTYPES,
    GET_RETRIEVEVEHICLETYPES,
    GET_CURRENTROOM,
    INITIALIZE_PRINT_INVENTORY,
    SET_PRINT_INVENTORY,
    SET_VEHICLE_INVENTORY,
    GET_ENGINE_TYPE,
    INITIALIZE_INVENTORY_ITEMS,
    SET_INVENTORY_ITEM,
    UPDATING_INVENTORY,
} from '../actions/inventory';

const initialState = Map({
    inventoryDetails: {},
    roomTypes: [],
    householdItemTypes: [],
    vehicleTypes: [],
    currentRoom: {},
    printInventoryRoom: {
        regular: [],
        vehicle: true,
    },
    engineTypes: [],
    inventoryItems: [],
    updatingInventory: false,
});

const actionsMap = {
    [GET_RETRIEVEINVENTORY]: (state, action) => {
        return state.set('inventoryDetails', action.inventoryDetails);
    },
    [GET_RETRIEVEROOMTYPES]: (state, action) => {
        return state.set('roomTypes', action.roomTypes);
    },
    [GET_HOUSEHOLDITEMTYPES]: (state, action) => {
        return state.set('householdItemTypes', action.householdItemTypes);
    },
    [GET_RETRIEVEVEHICLETYPES]: (state, action) => {
        return state.set('vehicleTypes', action.vehicleTypes);
    },
    [GET_CURRENTROOM]: (state, action) => {
        return state.set('currentRoom', action.currentRoom);
    },
    [INITIALIZE_PRINT_INVENTORY]: (state, action) => {
        const isEmptyArray = new Array(action.length).fill(true);
        const printInventoryRoom = {
            regular: isEmptyArray,
            vehicle: true,
        }
        return state.set('printInventoryRoom', printInventoryRoom);
    },
    [INITIALIZE_INVENTORY_ITEMS]: (state, action) => {
        return state.set('customItems', action.items);
    },
    [SET_INVENTORY_ITEM]: (state, action) => {
        const updatedCustomItems = [...state.get('customItems')];
        updatedCustomItems[action.index] = action.dataSet;
        return state.set('customItems', updatedCustomItems);
    },
    [SET_PRINT_INVENTORY]: (state, action) => {
        const updatedPrintInventoryRoom = {...state.get('printInventoryRoom')};
        const updatedRegularRoom = [...updatedPrintInventoryRoom.regular]
        updatedRegularRoom[action.index] = action.isEmpty;
        updatedPrintInventoryRoom.regular = updatedRegularRoom;
        return state.set('printInventoryRoom', updatedPrintInventoryRoom);
    },
    [SET_VEHICLE_INVENTORY]: (state, action) => {
        const updatedPrintInventoryRoom = {...state.get('printInventoryRoom')};
        updatedPrintInventoryRoom.vehicle = action.isEmpty;
        return state.set('printInventoryRoom', updatedPrintInventoryRoom);
    },
    [GET_ENGINE_TYPE]: (state, action) => {
        return state.set('engineTypes', action.engineTypes);
    },
    [UPDATING_INVENTORY]: (state, action) => {
        return state.set('updatingInventory', action.updating);
    },
};

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}